module.exports = __webpack_public_path__ + "img/20190528162212316.304757c6.png";